import { connect } from "react-redux";
import { Box, Typography, Paper } from "@mui/material";

const statusColor = {
    New: "#4CAF50",
    Assigned: "#FF9800",
    "In Progress": "#2196F3",
    "Awaiting Customer Response": "#FFC107",
    Resolved: "#9C27B0",
    Closed: "#E53935",
};

const TicketsSummary = ({ title = "tickets", items = [], translate }) => {
    const totalCount = items.reduce((sum, item) => sum + (item.count || 0), 0);

    return (
        <Box sx={{ width: 300, p: 2, mt: 5 }}>
            <Typography variant="h5" fontWeight="bold" mb={2}>
                {totalCount.toLocaleString()} {translate(title)}
            </Typography>
            {items.map((item, index) => (
                <Paper
                    key={index}
                    elevation={0}
                    sx={{
                        backgroundColor: statusColor[item.status] || "#999",
                        color: "#fff",
                        borderRadius: 2,
                        px: 2,
                        py: 1.5,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 1.5,
                    }}
                >
                    <Typography variant="body1">{translate(item.status)}</Typography>
                    <Typography variant="h6" fontWeight="bold">
                        {item.count}
                    </Typography>
                </Paper>
            ))}
        </Box>
    );
};

const CRC = ({ taskCounts, translate }) => {
    return (
        <div className="fms-sidebar sidebar-bg-layer">
            <TicketsSummary title="tickets" items={taskCounts || []} translate={translate} />
        </div>
    );
};
const mapState = (state) => ({
    themecolors: state.themeColors,
});

export default connect(mapState)(CRC);